<template>
  <div class="bl-client-targets bg-slate-200">
    <TargetPanel
      :id="id"
      :newTargetOpened="newTargetOpened"
      :taskOfTarget="taskOfTarget"
      :activeTask="activeTask"
      @toggle-active-task="toggleActiveTask"
      @toggle-task-target-opened="toggleTaskTargetOpened"
      @toggle-new-target-opened="toggleNewTargetOpened"
      @toggle-target-loading="toggleTargetLoading"
    />
    <div class="bl-target-details">
      <div v-if="targetLoading" class="absolute z-20 w-full h-full">
        <div
          class="absolute w-full h-full opacity-75 bg-pure-white rounded-3xl"
        ></div>
        <div class="absolute z-20 grid w-full h-full place-items-center">
          <div class="blum-loader"></div>
        </div>
      </div>
      <TargetProperty
        v-if="target"
        :target="target"
        :taskTarget="activeTask"
        :graphEntries="graphEntries"
        @updateTaskTarget="updateTaskTarget"
        @select-task="selectTask"
        :entries="entries"
      />
      <div v-else class="bl-target-details-panel-empty text-grey-400">
        <div v-if="totalTargets" class="bl-target-details-message">
          <BlTextBody1 text="Click the target card to view the details." />
        </div>
        <div v-else class="bl-target-details-message">
          <BlTextBody1
            text="Currently, there are no targets to display. Once you create a new"
          />
          <div class="flex items-center justify-center gap-1 text-center">
            <BlTextBody1 text="target, it will appear here." />
            <BlInputButton
              label="Create a new target."
              class="p-0 bl-target-details-message-highlight"
              type="plain"
              @clicked="toggleNewTargetOpened(true)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import TargetPanel from "./target/Panel.vue";
import TargetProperty from "./target/Property.vue";

import BlTextBody1 from "../BlTextBody1.vue";
import BlInputButton from "../BlInputButton.vue";

export default {
  name: "ClientTarget",
  components: {
    TargetPanel,
    TargetProperty,
    BlTextBody1,
    BlInputButton
  },
  props: ["id"],
  data() {
    return {
      newTargetOpened: false,
      targetLoading: false,
      taskOfTarget: null,
      taskTargetOpened: false,
      activeTask: null
    };
  },
  computed: {
    ...mapGetters(["target", "entries", "graphEntries", "totalTargets"]),
    targetTasks() {
      if (!this.target) return [];
      if (!this.target.target_tasks) return [];
      if (!this.target.target_tasks.length) return [];
      return this.target.target_tasks;
    }
  },
  watch: {
    targetTasks: {
      deep: true,
      handler(val) {
        if (!this.activeTask) return;
        const task = val.find(i => i.id === this.activeTask.id);
        if (task) this.activeTask = task;
      }
    }
  },
  methods: {
    toggleNewTargetOpened(val) {
      this.newTargetOpened = val;
    },
    toggleTargetLoading(val) {
      this.targetLoading = val;
    },
    toggleTaskTargetOpened(val) {
      this.taskOfTarget = val;
    },
    toggleActiveTask(val) {
      this.activeTask = val;
    },
    updateTaskTarget(val) {
      this.activeTask = val;
    },
    selectTask(task) {
      this.activeTask = task;
    }
  }
};
</script>

<style scoped lang="scss">
.bl-client-targets {
  position: relative;
  width: 100%;
  height: calc(100vh - 4.5rem);
  // height: calc(100vh - 10.625rem);
  box-sizing: border-box;
  display: flex;

  .bl-target-details {
    position: relative;
    width: calc(100vw - 30rem - 0.5rem);
    height: 100%;
    box-sizing: border-box;
  }

  .bl-target-details-panel-empty {
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;

    .bl-target-details-message {
      position: relative;
      width: 100%;
      text-align: center;

      .bl-target-details-message-highlight {
        cursor: pointer;
        position: relative;
        color: var(--primary-color);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/clients/ClientTarget.vue